import React from 'react';
function Replace({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.166 2.833l3.333 3.334L16.166 9.5" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 11.167V9.5a3.333 3.333 0 013.333-3.333H19.5M7.833 21.167L4.5 17.833 7.833 14.5"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 12.833V14.5a3.333 3.333 0 01-3.333 3.333H4.5"
      />
    </svg>
  );
}

export default Replace;
